import { styled, Box } from '@withjoy/joykit';

export const ThemesGrid = styled(Box)`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
`;
